import script from "./InfoListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoListItem.vue?vue&type=script&setup=true&lang=js"

import "./InfoListItem.vue?vue&type=style&index=0&id=f03b204c&lang=scss"

const __exports__ = script;

export default __exports__